export default __webpack_public_path__ + "static/media/lock-gray-icon.2910ca0f.svg";